export default __webpack_public_path__ + "static/media/Jacket.58fadea5.png";